import type { paths } from "@/api-schema";
import { alphartisApiAxios } from "@/config/axios";
import { useMutation, useQueryClient } from "@tanstack/react-query";

export const GROUP_UPDATE_RESOURCE = "group" as const;
export const GROUP_UPDATE_API_PATH = `/v1/${GROUP_UPDATE_RESOURCE}/{uuid}` as const;

export type GroupUpdateBody =
  paths[typeof GROUP_UPDATE_API_PATH]["patch"]["requestBody"]["content"]["application/json"];
export type GroupUpdateResponse =
  paths[typeof GROUP_UPDATE_API_PATH]["patch"]["responses"][200]["content"]["application/json"];

export const useGroupUpdateMutation = (uuid: string) => {
  const queryClient = useQueryClient();

  return useMutation<GroupUpdateResponse, Error, GroupUpdateBody>({
    mutationFn: async (group: GroupUpdateBody) => {
      const { ...rest } = group;
      const response = await alphartisApiAxios.patch<GroupUpdateResponse>(`/v1/${GROUP_UPDATE_RESOURCE}/${uuid}`, rest);
      return response.data;
    },
    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: [GROUP_UPDATE_RESOURCE],
      });
    },
  });
};
